module.exports = __webpack_public_path__ + "static/media/81c0799b.jpg";